import {
  AppInfo,
  ContactInfo,
  DepartmentList,
  GroupInfo,
  JoySpaceInfo,
  TaskInfo,
  SearchType
} from "@/services/SearchService";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { getHighlightComp, getTelHighlightComp, getHighlightCompWithLabel } from "@/utils/search";
import React from "react";
import { getAvatarURLFn, SearchGlobalFn } from "./Tabs";
import Bus from "@/utils/bus";
import { UserCardAction, UserCardType } from "@/types/UserCard";
import styles from "@/components/styles";
import userCardIcon from "@/assets/img/user-card-icon.png";
import defaultDeptAvatarPng from "@/assets/img/default_dept_avatar.png"
import defaultVirtualAvatarPng from "@/assets/img/default_virtual_avatar.png"
import { IconDefualtOrg, IconDefualtWorkLine } from "@/components/icon";
import { ScheduleInfo } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import ImService from "@/server/ImService";
import { Session, EmployeeAttribute } from "@/types/chat";
import { isFunction, uniqBy } from "lodash";
import PinyinMatch from "pinyin-match";
import { appItemMenus } from "@/components/ThirdApp/components/ThirdMenu";
import { info } from "console";
import { getDeptPositionDesc } from "@/models/user";
import { getWebEnvObj } from "@/utils";
import { setUserTypeChange } from "@/components/Tags";
import { isTopSession } from "@/utils/chat/message";
import { timeSlot } from "./ConditionSearch";
import dayjs from "dayjs";
import { SubInfo } from "@/types/sub";

const { REACT_APP_JOYSPACE_API_HOST } = getWebEnvObj();

export function filterAppInfo(apps: AppInfo[]): ListItemData[] {
  return (apps || []).map((item) => {
    const { appId, appName, avatar, highlight, description = "", brief = "", ext } = item;
    const { builder, developer } = ext;
    const desc = brief || appName || "";
    return {
      id: appId,
      name: getHighlightComp(highlight, "appName", appName),
      brief: getHighlightComp(highlight, "brief", brief),
      builder: getHighlightComp(highlight, "builder", builder),
      developer: getHighlightComp(highlight, "developer", developer),
      desc,
      avatar,
      origin: item,
      searchKey: SearchType.App
    };
  });
}

function getJoySpaceDocIconByPageType(title: string, pageType: string, type: string) {
  return `${REACT_APP_JOYSPACE_API_HOST}/v1/common/icons?title=${encodeURIComponent(
    title
  )}&pageType=${pageType}&type=${type}&client=web`;
}

export function onOpenUserCard(data: any) {
  const { userId, appId, teamId } = data;
  Bus.emit("app:toggle-user-card-modal:show", {
    visible: true,
    type: UserCardType.User,
    userId,
    teamId,
    appId,
    applyInfos: [],
    actions: [UserCardAction.Chat]
  });
}

export function filterJoySpaceInfo(pages: JoySpaceInfo[]): ListItemData[] {
  return (pages || []).map((item) => {
    const { id, title, pageType, highlight, type, content, previewText } = item;
    return {
      id,
      name: getHighlightComp(highlight, "title", title),
      con: getHighlightComp(highlight, "content", content ? content : previewText),
      avatar: item.icon_url || getJoySpaceDocIconByPageType(title, pageType, type),
      origin: item,
      searchKey: SearchType.JoySpace
    };
  });
}
export function filterScheduleInfo(pages: ScheduleInfo[]): ListItemData[] {
  return (pages || []).map((item) => {
    const { title, highlight } = item;
    return {
      id: item.scheduleId,
      name: getHighlightComp(highlight, "title", title),
      avatar: getJoySpaceDocIconByPageType(title, "1", "1"),
      origin: item,
      searchKey: SearchType.Schedule
    };
  });
}

// eslint-disable-next-line max-params
export function searchClientContacts(
  allSessionList: Session[],
  contacts: ListItemData[],
  keyWord: string,
  currentEmployee: any,
  followUserList: any[] = []
): ListItemData[] {
  const result: ListItemData[] = [];
  const top: ListItemData[] = [];
  // eslint-disable-next-line complexity
  const followList = followUserList.map((i) => ({
    ...i,
    info: i,
    desc: getDeptPositionDesc({
      deptName: i.partTimeTitleDeptInfo?.[0]?.deptName || "",
      titleName: i.partTimeTitleDeptInfo?.[0]?.titleName || "",
      unitName: i.partTimeTitleDeptInfo?.[0]?.unitName || "",
      userType: i.userType
    }),
    realRemark: i.remark,
    avatar: i.fields.find((f: any) => f.key === "avatar")?.val || "",
    id: `${i.userId}:${i.appId}:${i.teamId}`
  }));
  // eslint-disable-next-line complexity
  uniqBy([...followList, ...allSessionList], "id").forEach((item: any) => {
    const name = item?.info?.name || item.name;
    const data: any = PinyinMatch.match(name, keyWord);
    const isTop = isTopSession(item);
    const userType = setUserTypeChange(item?.info, currentEmployee);
    if (data?.length) {
      // 网络接口有数据 显示网络的数据
      const list: ListItemData[] = contacts.filter(
        (elm1) => item.info?.id === elm1.id || item.id === elm1.id
      );
      if (list.length > 0) {
        if (isTop) {
          top.push(list[0]);
        } else {
          result.push(list[0]);
        }
      } else {
        const sliceName = (item?.info?.name || item.name).slice(data?.[0], data?.[1] + 1);
        const deptInfo = item?.info?.partTimeTitleDeptInfo?.[0] || item.info || item;
        const descValue = getDeptPositionDesc({
          deptName: deptInfo.deptName,
          titleName: deptInfo.titleName,
          unitName: deptInfo.unitName,
          userType
        });
        const highlight = [
          {
            key: sliceName,
            name: "name",
            value: name
          },
          { key: keyWord, name: "desc", value: descValue }
        ];
        const desc = getHighlightComp(highlight, "desc", descValue);
        const userId = item?.info?.userId || item.userId;
        const teamId = item?.info?.teamId || item.teamId;
        const app = item?.info?.app || item.app || item.appId;
        const employeeExt = item.info?.employeeExt || {};
        const resultUser = {
          id: userId + ":" + app + ":" + teamId,
          avatar: item?.info?.avatar || item.avatar,
          displayName: item?.info?.name || item.name,
          desc,
          realDesc: descValue,
          highlight,
          labelInfoList: item.labelInfoList || item?.info?.labelInfoList || [],
          userId,
          teamId,
          app,
          name: getHighlightComp(highlight, "name", name),
          searchKey: SearchType.Contacts,
          deptName: item?.info?.deptName || item?.deptName,
          titleName: item?.info?.titleName || item?.titleName,
          unitName: item?.info?.unitName || item?.unitName,
          deptId: item?.info?.deptId || item?.deptId,
          unitDeptId: item?.info?.unitDeptId || item?.unitDeptId,
          userType: setUserTypeChange(
            { ...item?.info, userType: employeeExt.userType },
            currentEmployee
          ),
          remark: getHighlightComp(highlight, "remark", employeeExt.remark || item.remark),
          origin: {
            ...item,
            userId,
            teamId,
            app
          }
        };
        if (isTop) {
          top.push(resultUser);
        } else {
          result.push(resultUser);
        }
      }
    }
  });
  return [...top, ...result];
}

// eslint-disable-next-line max-params
export function filterContactInfo({
  contacts,
  allSessionList,
  keyWord,
  followUserList,
  currentEmployee,
  hasNoResult
}: {
  contacts: ContactInfo[];
  allSessionList: Session[];
  keyWord: string;
  followUserList?: any[];
  currentEmployee: any;
  hasNoResult?: boolean;
}): ListItemData[] {
  const contactsList = (contacts || []).map((item) => {
    const {
      userId,
      realName,
      avatar,
      highlight,
      labelInfoList,
      app,
      teamId,
      ebookTag,
      remark
    } = item;
    const userType = setUserTypeChange(item, currentEmployee);
    const descValue = getDeptPositionDesc({
      deptName: item?.deptName,
      titleName: item?.titleName || "",
      unitName: item?.unitName,
      userType
    });
    const descHighlight = [{ key: keyWord, name: "desc", value: descValue }];
    const desc = getHighlightComp(descHighlight, "desc", descValue);
    const remarkHighlight = [{ key: keyWord, name: "remark", value: remark }];
    const telHighlight = highlight.find((h) => h.name === "titleList.telephone");
    const tagHighlight = ebookTag
      ? highlight.find((h) => h.name === "ebookTags.tag" && h.value === ebookTag)
      : "";
    const highlightTag = tagHighlight
      ? getHighlightCompWithLabel("分组", tagHighlight, "ebookTags.tag")
      : "";
    const remarkComps: any[] = [];
    if (remark) {
      remarkComps.push(getHighlightComp(remarkHighlight, "remark", item.remark));
    }
    if (telHighlight) {
      if (remarkComps.length) {
        remarkComps.push(")(");
      }
      remarkComps.push(getTelHighlightComp(telHighlight));
    }
    return {
      id:
        userId +
        ":" +
        (app ||
          (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID ||
          process.env.REACT_APP_DD_APPID ||
          "") +
        ":" +
        teamId,
      name: getHighlightComp(highlight, "realName", realName),
      avatar,
      displayName: realName,
      origin: item,
      desc: highlightTag ? highlightTag : desc,
      realDesc: descValue,
      // desc: item.deptName + '-' + item?.titleName,
      searchKey: SearchType.Contacts,
      labelInfoList: labelInfoList || [],
      userId: userId,
      remark: remarkComps,
      realRemark: remark
    };
  });
  // 请求到结果就不返回本地结果
  if (hasNoResult === false) {
    return contactsList;
  }
  if (!allSessionList || !allSessionList.length) {
    return contactsList || [];
  }
  const singleSessionList = allSessionList.filter(
    (ele: Session) => ele.isSingle && !ele.isNotice && ele.info?.name
  );
  let result: ListItemData[] = searchClientContacts(
    singleSessionList,
    contactsList,
    keyWord,
    currentEmployee,
    followUserList
  );
  // 大搜联系人列表中不需要显示机器人, 也不需要显示组织号
  const list = (uniqBy([...result, ...contactsList], "id") || []).filter(
    (itm) => !itm.id.startsWith("robot_") && !itm.id.startsWith("sub_")
  );
  if (!followUserList?.length) {
    return list;
  }
  // 特别关注置顶
  return list.sort(
    (a, b) =>
      followUserList.findIndex((i) => `${i.userId}:${i.appId}:${i.teamId}` === b.id) -
      followUserList.findIndex((i) => `${i.userId}:${i.appId}:${i.teamId}` === a.id)
  );
}

export function filterDeptsInfo(Depts: DepartmentList[]): ListItemData[] {
  return (Depts || []).map((item) => {
    const { deptId, highlight, deptName, realFullName, fullPath, fullName, nodeType } = item;
    const filterHighlight: any =
      highlight.length > 0
        ? highlight.map((item) => {
            if (item.name === "fullName") {
              return {
                ...item,
                name: "realFullName",
                key: item.key?.split(",")[0] || item.key
              };
            }
            return item;
          })
        : realFullName;

    const desc =
      highlight.length === 0 || highlight.findIndex((a) => a.name === "deptName") >= 0
        ? realFullName
        : getHighlightComp(filterHighlight, "realFullName", item.realFullName);

    return {
      id: deptId,
      name: getHighlightComp(filterHighlight, "deptName", deptName),
      avatar: nodeType === "1" ? defaultVirtualAvatarPng : defaultDeptAvatarPng,
      searchKey: SearchType.Department,
      title: deptName,
      key: deptId,
      fullPath: fullPath,
      fullName: fullName,
      desc,
      origin: item
    };
  });
}

export function filterGroupInfo(groups: GroupInfo[]): ListItemData[] {
  return (groups || []).map((item) => {
    const { groupId, groupName, avatar, highlight } = item;
    return {
      id: groupId,
      name: getHighlightComp(highlight, "groupName", groupName),
      displayName: groupName,
      avatar,
      origin: item,
      searchKey: SearchType.Group,
      desc: (item.groupUserCount || 0) + "人" || "",
      kind: item.kind,
      subKind: item.subKind
    };
  });
}

// export async function groupsSort(groups: any) {
//   const imService = ImService.getInstance();
//   const sids = groups.map((item: any) => {
//     return item.groupId;
//   });
//   const curSessions = await imService.getSessionBySessionIds(sids);
//   // 排序 置顶群优先&&lastMsg时间戳降序
//   curSessions.sort((a: any, b: any) => {
//     const topA = a.settings?.top ? a.settings.top : 0;
//     const topB = b.settings?.top ? b.settings.top : 0;
//     const timeA = a?.lastMsg ? a.lastMsg.timestamp : -999;
//     const timeB = b?.lastMsg ? b.lastMsg.timestamp : -999;
//     if (topA !== topB) {
//       return topB - topA;
//     } else {
//       return timeB - timeA;
//     }
//   });
//   const existsSession = curSessions.map((item: any) => {
//     return groups.find((g: any)=> g.groupId === item.id);
//   });
//   const filterResSession = groups.filter((item: any) => {
//     return curSessions.findIndex((s: any) => s.sessionId === item.groupId) === -1;
//   });
//   return [...existsSession, ...filterResSession];
// }

export async function groupsSort(groups: any) {
  const imService = ImService.getInstance();
  const sessionIds = groups.map((item: any) => item.groupId);
  const curSessions = await imService.getSessionBySessionIds(sessionIds);

  const sessionById = new Map(curSessions.map((session: any) => [session.id, session]));

  return groups.sort((a: any, b: any) => {
    const sessionA: any = sessionById.get(a.groupId) || {};
    const sessionB: any = sessionById.get(b.groupId) || {};

    const topA = sessionA.settings?.top ?? 0;
    const topB = sessionB.settings?.top ?? 0;
    const timeA = sessionA.lastMsg?.timestamp ?? -999;
    const timeB = sessionB.lastMsg?.timestamp ?? -999;

    if (topA !== topB) {
      return topB - topA;
    } else {
      return timeB - timeA;
    }
  });
}

export function filterTaskInfo(works: { [key: string]: any }[]) {
  if (!works) return {};
  const res: any = [];
  works.forEach((item, idx) => {
    res[idx] = {
      displayName: item.displayName,
      data: item.data?.map((item: TaskInfo) => {
        const { taskId, title, priorityType, highlight } = item;
        return {
          id: taskId,
          name: getHighlightComp(highlight, "title", title),
          displayName: title,
          avatar: priorityType,
          origin: item,
          searchKey: SearchType.Task
        };
      })
    };
  });
  return res;
}

export function getStartEndTime(timeRange: timeSlot) {
  const timeObj: any = {};
  const now = dayjs();
  switch (timeRange) {
    case timeSlot.today:
      timeObj.beginTime = now.startOf("date").valueOf();
      timeObj.endTime = now.endOf("date").valueOf();
      break;
    case timeSlot.tomorrow:
      timeObj.beginTime = now.add(1, "day").startOf("date").valueOf();
      timeObj.endTime = now.add(1, "day").endOf("date").valueOf();
      break;
    case timeSlot.thisWeek:
      if (now.day() === 0) {
        timeObj.beginTime = now.subtract(1, "day").startOf("week").add(1, "day").valueOf();
        timeObj.endTime = now.subtract(1, "day").endOf("week").add(1, "day").valueOf();
      } else {
        timeObj.beginTime = now.startOf("week").add(1, "day").valueOf();
        timeObj.endTime = now.endOf("week").add(1, "day").valueOf();
      }
      break;
    case timeSlot.nextWeek:
      if (now.add(1, "week").day() === 0) {
        timeObj.beginTime = now
          .add(1, "week")
          .subtract(1, "day")
          .startOf("week")
          .add(1, "day")
          .valueOf();
        timeObj.endTime = now
          .add(1, "week")
          .subtract(1, "day")
          .endOf("week")
          .add(1, "day")
          .valueOf();
      } else {
        timeObj.beginTime = now.add(1, "week").startOf("week").add(1, "day").valueOf();
        timeObj.endTime = now.add(1, "week").endOf("week").add(1, "day").valueOf();
      }
      break;
    case timeSlot.thisMonth:
      timeObj.beginTime = now.startOf("month").valueOf();
      timeObj.endTime = now.endOf("month").valueOf();
      break;
    case timeSlot.nextMonth:
      timeObj.beginTime = now.add(1, "month").startOf("month").valueOf();
      timeObj.endTime = now.add(1, "month").endOf("month").valueOf();
      break;
    default:
      break;
  }
  return timeObj;
}

export const SearchGlobalContext = React.createContext<{
  t: any;
  onGetAvatarURL?: getAvatarURLFn;
  onSearchGlobal: SearchGlobalFn;
  keyword: string;
  activeKey: SearchType;
  setTabIndex: (activeKey: SearchType) => void;
  authData: any;
  isChange?: boolean;
  folderIds?: Array<string>;
  types?: Array<string>;
  joyTypeList?: [];
  taskStatus?: number[];
  taskDeadlineTime?: timeSlot;
  scheduleDeadlineTime?: timeSlot;
  fileTypeList?: [];
  taskPriorityType?: number[];
  scheduleColor?: string[];
  searchValue: string;
  msgType?: string;
  senderList?: any;
  sessionType?: string;
  msgTime?: any;
}>({
  t: () => {},
  onSearchGlobal: async () => ({}),
  keyword: "",
  searchValue: "",
  setTabIndex: () => {},
  activeKey: SearchType.All,
  authData: null
});
